import { render, staticRenderFns } from "./OneDataColumn.vue?vue&type=template&id=5567b620"
import script from "./OneDataColumn.vue?vue&type=script&lang=js"
export * from "./OneDataColumn.vue?vue&type=script&lang=js"
import style0 from "./OneDataColumn.vue?vue&type=style&index=0&id=5567b620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports